<template>
  <div class="entire_client_app__sidebar">
    <div
      :class="{
        '--sidebar_toggled_expd_user_account_container':
          $store.state.SidebarToggle.sidebar_toggled,
      }"
      class="user_account_container"
    >
      <div
        :class="{
          '--sidebar_toggled_hide_user_avatar':
            $store.state.SidebarToggle.sidebar_toggled,
        }"
        class="user_avatar"
      >
        <div class="image">
          <img
            v-if="user.photo == ''"
            src="../assets/default.png"
            alt="avatar"
          />
          <img v-else :src="user.photo" alt="avatar" />
        </div>
      </div>
      <div
        :class="{
          '--sidebar_toggled_hide_user_details':
            $store.state.SidebarToggle.sidebar_toggled,
        }"
        class="user_details"
      >
        <h2>{{ user.firstname }} {{ user.lastname }}</h2>
        <p class="post">{{ branch.branchname }} Branch Shaloi</p>
        <!-- <div class="promo_level_container">
                    <router-link to="/shaloi/profile"><p>Matunda Express Shaloi</p></router-link>
                </div> -->
      </div>
    </div>
    <div
      :class="{
        '--sidebar_toggled_hide_nav_container':
          $store.state.SidebarToggle.sidebar_toggled,
      }"
      class="navigation_container"
    >
      <div class="navigation_links">
        <router-link
          to="/shaloi/dashboard"
          @click="$store.commit('Customizations/togglemobilesidebar')"
        >
          <div class="navigation_link_content">
            <div
              :class="{
                '--sidebar_toggled_hide_link_icon_full_width':
                  $store.state.SidebarToggle.sidebar_toggled,
              }"
              class="link_icon"
            >
              <svg
                id="dashboard-line"
                xmlns="http://www.w3.org/2000/svg"
                width="28"
                height="28"
                viewBox="0 0 28 28"
              >
                <path
                  id="Path_13"
                  data-name="Path 13"
                  d="M0,0H28V28H0Z"
                  fill="none"
                />
                <path
                  class="active_icon"
                  id="Path_14"
                  data-name="Path 14"
                  d="M15.222,25V12.778H25V25ZM3,15.222V3h9.778V15.222Zm7.333-2.444V5.444H5.444v7.333ZM3,25V17.667h9.778V25Zm2.444-2.444h4.889V20.111H5.444Zm12.222,0h4.889V15.222H17.667ZM15.222,3H25v7.333H15.222Zm2.444,2.444V7.889h4.889V5.444Z"
                  transform="translate(0 0)"
                  fill="#1D2329"
                />
              </svg>
            </div>
            <div
              :class="{
                '--sidebar_toggled_hide_link_name':
                  $store.state.SidebarToggle.sidebar_toggled,
              }"
              class="link_name"
            >
              Dashboard
            </div>
          </div>
        </router-link>

        <router-link
          to="/shaloi/transactions"
          @click="$store.commit('Customizations/togglemobilesidebar')"
        >
          <div class="navigation_link_content">
            <div
              :class="{
                '--sidebar_toggled_hide_link_icon_full_width':
                  $store.state.SidebarToggle.sidebar_toggled,
              }"
              class="link_icon"
            >
              <svg
                id="exchange-funds-line"
                xmlns="http://www.w3.org/2000/svg"
                width="28"
                height="28"
                viewBox="0 0 28 28"
              >
                <path
                  id="Path_100"
                  data-name="Path 100"
                  d="M0,0H28V28H0Z"
                  fill="none"
                />
                <path
                  class="active_icon"
                  id="Path_101"
                  data-name="Path 101"
                  d="M22.785,17.724A9.649,9.649,0,0,0,20.321,6.812,9.476,9.476,0,0,0,9.271,5.664L8.089,3.579a11.832,11.832,0,0,1,11.867.029,12.046,12.046,0,0,1,4.9,15.324l1.6.929L21.5,22.517l-.2-5.657,1.484.863ZM5.215,10.276A9.649,9.649,0,0,0,7.68,21.188a9.476,9.476,0,0,0,11.05,1.149l1.182,2.084a11.832,11.832,0,0,1-11.867-.029A12.046,12.046,0,0,1,3.14,9.068l-1.6-.928L6.5,5.484l.2,5.657-1.484-.863Zm10.471,7.117L12.313,14,8.945,17.394,7.26,15.7l5.054-5.09L15.684,14l3.37-3.394,1.684,1.7-5.054,5.09Z"
                  transform="translate(0 0)"
                  fill="#1D2329"
                />
              </svg>
            </div>
            <div
              :class="{
                '--sidebar_toggled_hide_link_name':
                  $store.state.SidebarToggle.sidebar_toggled,
              }"
              class="link_name"
            >
              Transactions
            </div>
          </div>
        </router-link>
        <router-link
          to="/shaloi/support"
          @click="$store.commit('Customizations/togglemobilesidebar')"
        >
          <div class="navigation_link_content">
            <div
              :class="{
                '--sidebar_toggled_hide_link_icon_full_width':
                  $store.state.SidebarToggle.sidebar_toggled,
              }"
              class="link_icon"
            >
              <svg
                id="customer-service-2-line"
                xmlns="http://www.w3.org/2000/svg"
                width="28"
                height="28"
                viewBox="0 0 28 28"
              >
                <path
                  id="Path_23"
                  data-name="Path 23"
                  d="M0,0H28V28H0Z"
                  fill="none"
                />
                <path
                  class="active_icon"
                  id="Path_24"
                  data-name="Path 24"
                  d="M23.381,9.273h1.255A2.364,2.364,0,0,1,27,11.636v4.727a2.364,2.364,0,0,1-2.364,2.364H23.381A9.456,9.456,0,0,1,14,27V24.636a7.091,7.091,0,0,0,7.091-7.091V10.454a7.091,7.091,0,1,0-14.182,0v8.273H3.364A2.364,2.364,0,0,1,1,16.364V11.636A2.364,2.364,0,0,1,3.364,9.273H4.619a9.456,9.456,0,0,1,18.763,0ZM3.364,11.636v4.727H4.545V11.636Zm20.091,0v4.727h1.182V11.636ZM8.989,18.473l1.253-2a7.1,7.1,0,0,0,7.516,0l1.253,2a9.461,9.461,0,0,1-10.022,0Z"
                  transform="translate(0)"
                  fill="#1d2329"
                />
              </svg>
            </div>
            <div
              :class="{
                '--sidebar_toggled_hide_link_name':
                  $store.state.SidebarToggle.sidebar_toggled,
              }"
              class="link_name"
            >
              Support
            </div>
          </div>
        </router-link>
        <router-link
          to="/dashboard"
          @click="$store.commit('Customizations/togglemobilesidebar')"
        >
          <div class="navigation_link_content">
            <div
              :class="{
                '--sidebar_toggled_hide_link_icon_full_width':
                  $store.state.SidebarToggle.sidebar_toggled,
              }"
              class="link_icon"
            >
              <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="24" height="24"><path fill="none" d="M0 0h24v24H0z"/><path d="M12 2c3.5 0 6 3 7 6 3 1 4 3.73 4 6l-2.775.793a1 1 0 0 0-.725.961v1.496A1.75 1.75 0 0 1 17.75 19h-.596a2 2 0 0 0-1.668.896C14.558 21.3 13.396 22 12 22c-1.396 0-2.558-.701-3.486-2.104A2 2 0 0 0 6.846 19H6.25a1.75 1.75 0 0 1-1.75-1.75v-1.496a1 1 0 0 0-.725-.961L1 14c0-2.266 1-5 4-6 1-3 3.5-6 7-6zm0 2C9.89 4 7.935 5.788 6.989 8.371l-.092.261-.316.95-.949.315c-1.255.419-2.067 1.341-2.424 2.56l-.023.086 1.14.327a3 3 0 0 1 2.17 2.703l.005.181V17h.346a4 4 0 0 1 3.2 1.6l.136.192C10.758 19.663 11.316 20 12 20c.638 0 1.167-.293 1.703-1.04l.115-.168a4 4 0 0 1 3.1-1.785l.236-.007h.346v-1.246a3 3 0 0 1 2.003-2.83l.173-.054 1.139-.327-.023-.087c-.337-1.151-1.08-2.037-2.22-2.484l-.204-.075-.95-.316-.315-.949C16.195 5.91 14.18 4 12 4zm0 8c.828 0 1.5 1.12 1.5 2.5S12.828 17 12 17s-1.5-1.12-1.5-2.5.672-2.5 1.5-2.5zM9.5 8a1.5 1.5 0 1 1 0 3 1.5 1.5 0 0 1 0-3zm5 0a1.5 1.5 0 1 1 0 3 1.5 1.5 0 0 1 0-3z"/></svg>
            </div>
            <div
              :class="{
                '--sidebar_toggled_hide_link_name':
                  $store.state.SidebarToggle.sidebar_toggled,
              }"
              class="link_name"
            >
              Client-dashboard
            </div>
          </div>
        </router-link>
      </div>
      <button @click="logout">Logout</button>
    </div>
    <div class="logout_btn">
      <p>Powered by Zexos Group</p>
    </div>
  </div>
</template>

<script>
import router from "../router/index";
// import { mapState } from 'vuex
export default {
  name: "Sidebar",

  data() {
    return {
      user: new String(),
      branch: new String(),
      levelOfPromotion: "Intermediate",
      levelsOfProGrade: "2 levels",
      companies: ["Volcano Ltd", "Matunda Express", "Stella Yigitarama"],
    };
  },

  computed: {},

  methods: {
    logout() {
      localStorage.removeItem("jwt");
      router.push("/");
    },
  },

  computed: {
    user() {
      var userDataToDisplay = this.$store.state.UserDetails.user;
      return Object.assign(this.user, userDataToDisplay);
    },
    branch() {
      var branchDataToDisplay = this.$store.state.UserDetails.branch;
      return Object.assign(this.branch, branchDataToDisplay);
    },
  },

  mounted() {
    this.$store.dispatch("UserDetails/getUser");
    this.$store.dispatch("UserDetails/getbranch");
  },
};
</script>

<style lang="scss" scoped>
.post {
  font-size: 13px !important;
}
.entire_client_app__sidebar {
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: space-around;
  flex-direction: column;

  & .user_account_container {
    height: 25%;
    width: 100%;
    margin-top: 8%;

    .user_avatar {
      height: 50%;
      width: 100%;
      display: flex;
      justify-content: center;
      align-items: center;

      & .image {
        width: 5em;
        height: 5em;
        overflow: hidden;
        border-radius: 50%;
        display: flex;
        align-items: center;
        justify-content: center;
        background: $routeShadows;

        img {
          width: 100%;
          height: auto;
        }
      }
    }

    .user_details {
      height: 50%;
      width: 100%;
      display: flex;
      flex-direction: column;
      align-items: center;
      margin-top: 1.2em;

      h2 {
        color: $mainDark;
        font-family: satoshi, $poppins;
        font-size: 1.1em;
      }

      .promo_level_container {
        width: 100%;
        height: auto;
        display: flex;
        justify-content: center;
        align-items: center;

        p {
          font-family: satoshi, $poppins;
          font-size: 0.72em;
          font-weight: 500;
          color: $dimerDark;
        }

        svg {
          margin: 0 0.5em;
        }

        .level_grades {
          color: $mainRed !important;
        }
      }
    }
  }

  & .navigation_container {
    height: 45%;
    width: 100%;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    background-color: $mainBlueLight;
    margin-top: 1em;

    button {
      width: 95%;
      height: 21.5%;
      margin-top: 2em;
      border: none;
      background: $mainBlue;
      color: $pureWhite;
      font-family: satoshi, $poppins;
      font-size: 0.86em;
      border-radius: 0.25em;
    }

    .navigation_links {
      width: 95%;
      height: 100%;
      border-radius: 0.25em;

      .navigation_link_content {
        width: 100%;
        height: 22%;
        border-radius: 0.22em;
        display: flex;
        align-items: center;
        margin-top: 0.5em;

        .link_icon {
          width: 20%;
          height: 100%;
          display: flex;
          align-items: center;
          justify-content: center;

          svg {
            width: 33%;
          }
        }

        .link_name {
          width: 80%;
          height: 100%;
          display: flex;
          align-items: center;
          font-family: satoshi, $poppins;
          font-size: 0.87em;
          font-weight: 580;
        }
      }
    }
  }

  & .logout_btn {
    width: 100%;
    height: 10%;
    display: flex;
    justify-content: center;
    align-items: center;

    p {
      font-family: satoshi, $poppins;
      font-size: 0.8em;
      opacity: 0.7;
    }
  }
}
</style>
